import { useGetKpisQuery } from '../../app/api';
import { useActiveAlerts } from '../alerts/selectors';

interface Cell {
  label: string;
  value: string;
  color: string;
  suffix?: string;
}

export function KpiStrip() {
  const { data } = useGetKpisQuery(undefined, { pollingInterval: 5000 });
  // ACTIVE ALERTS + NETWORK HEALTH are client-owned now (the backend holds no
  // alert state); same health formula the old StatsService used.
  const active = useActiveAlerts().length;
  const networkHealth = `${Math.max(50, 100 - Math.min(48, active))}%`;

  const cells: Cell[] = [
    { label: 'TOWERS MONITORED', value: data?.towersMonitored ?? '—', color: 'var(--text-primary)' },
    { label: 'ACTIVE ALERTS', value: active.toLocaleString('en-US'), color: '#ff4d4d' },
    { label: 'RULES ENABLED', value: data?.rulesEnabled ?? '—', color: 'var(--text-primary)' },
    { label: 'MEAN DETECT', value: data?.meanDetect ?? '—', color: 'var(--accent)' },
    { label: 'NETWORK HEALTH', value: networkHealth, color: 'var(--ok)' },
  ];

  return (
    <div
      style={{
        height: 78,
        borderTop: '1px solid var(--border)',
        background: 'var(--surface-panel)',
        display: 'grid',
        gridTemplateColumns: 'repeat(5,1fr)',
      }}
    >
      {cells.map((c, i) => (
        <div
          key={c.label}
          style={{
            padding: '13px 18px',
            borderRight: i < cells.length - 1 ? '1px solid var(--border-subtle)' : 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          {/* Inter (not the wide display face) so the longest label stays on
              one line — the strip is a hard 78px and a wrapped label overflows. */}
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 0.8,
              color: 'var(--text-muted)',
              whiteSpace: 'nowrap',
            }}
          >
            {c.label}
          </span>
          <span className="mono" style={{ fontSize: 24, fontWeight: 600, color: c.color }}>
            {c.value}
          </span>
        </div>
      ))}
    </div>
  );
}
